import { Button, Typography } from "@mui/material";
import { Box, Container, Stack } from "@mui/system";
import { styled } from "@mui/system";
import text from "../Components/Assets/text.png";

import React from "react";

const Maintext = () => {
  const Text = styled(Typography)({
    fontFamily: "Gilroy",
    fontSize:"52px",
    fontWeight: "700",
    lineHeight: "64px",
    letterSpacing: "0em",
  });
  return (
    <>
      <Container>
        <Stack
          direction="row"
         
          sx={{
            flexDirection: { xs: "column", lg: "row" },
            justifyContent: { xs: "center" },
            paddingTop:{xs:"0%",md:"12%"}
          }}
        >
          <Box sx={{ color: "#ffffff",textAlign:{xs:"center",md:"start"} }} mt={10}>
            <Typography sx={{ color: "rgba(128, 171, 158, 1)" }}>
              Build the Future with{" "}
            </Typography>
            <Text>Blockchain technology</Text>
            <Text>and Currency</Text>
            <Button
              variant="outline"
              sx={{
                backgroundColor: "rgba(0, 227, 165, 1)",
                color: "rgba(24, 24, 24, 1)",
                fontWeight: "550",
                width: "312px",
                borderRadius: "8px",
                height: "15%",
                marginTop: "30px",
                "&:hover": {
                  backgroundColor: "rgba(0, 227, 165, 1)",
                },
              }}
            >
              Get Whitepaper
            </Button>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-end" },
            }}
          >
            <img
              src={text}
              alt="img"
              style={{ width: "80%", paddingright: { xs: "50px" } }}
            />
          </Box>
        </Stack>
      </Container>
    </>
  );
};

export default Maintext;
